import React, { Component } from 'react'

export default class CategoryWidget extends Component {
  static defaultProps = {
    categories: [],
    showHeader: true,
    showClearButton: true,
    useTotalPercentage: false,
    visibleCategories: Infinity,
    heading: '',
    description: '',
  }

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    // Bind complex objects and event listeners
    this.ref.current.addEventListener('categoriesSelected', this._onSelectedChanged.bind(this));
  }
  
  componentDidUpdate() {
    this.ref.current.categories = this.props.categories;
  }

  _onSelectedChanged(event) {
    const { onSelectedChanged } = this.props;
    onSelectedChanged && onSelectedChanged(event);
  }

  /**
   * Delegate function calls
   */
  async clearSelection() {
    await this.ref.current.clearSelection();
  }

  render() {
    return <as-category-widget
      ref={this.ref}
      heading={this.props.heading}
      description={this.props.description}
      show-header={this.props.showHeader}
      show-clear-button={this.props.showClearButton}
      use-total-percentage={this.props.useTotalPercentage}
      visible-categories={this.props.visibleCategories}
    />
  }
}